export type EmployeeProfilesListTranslation = {
  form: {
    regionsSelect: {
      east: string;
      headquarter: string;
      selectAll: string;
      south: string;
      west: string;
    };
  };
};

export const employeeProfilesListTranslation: EmployeeProfilesListTranslation = {
  form: {
    regionsSelect: {
      east: 'East',
      headquarter: 'Headquarter',
      selectAll: 'Select All',
      south: 'South',
      west: 'West',
    },
  },
};
